class WebStorage {
    constructor() {
        this.set = (key, value) => {
            const json = JSON.stringify(value);
            this.storage.setItem(key, json);
        };
        this.remove = (key) => {
            this.storage.removeItem(key);
        };
        this.get = (key) => {
            const json = this.storage.getItem(key);
            return JSON.parse(json);
        };
        this.pull = (key, defaultValue) => {
            const value = this.get(key);
            this.remove(key);
            if (value !== null) {
                return value;
            }
            return defaultValue;
        };
        this.getWebStorage = () => {
            const { localStorage } = window;
            if (localStorage)
                return { storage: localStorage, type: 'localStorage' };
            const { sessionStorage } = window;
            if (sessionStorage)
                return { storage: sessionStorage, type: 'sessionStorage' };
            throw Error('both localStorage and sessionStorage are not available');
        };
        const { storage, type } = this.getWebStorage();
        this.type = type;
        this.storage = storage;
    }
}
const webStorage = new WebStorage();
export default webStorage;
